// extracted by mini-css-extract-plugin
module.exports = {"lower":"style__lower__KzHWH"};